export default "__VITE_ASSET__D8cW68qu__"